export default (response: BlobPart, fileName: string, contentType: string) => {
  const blob = new Blob([response], { type: contentType })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName
  link.click()
}
